import axios from "axios";
import _ from "lodash";
import Vue from 'vue'
import StudyEstimationEukApiService from "../../../components/application/study/Services/Api/StudyEstimationEukApi";
import store from "../index.js.erb";

const studyEstimationEukApi = StudyEstimationEukApiService

const StudyEstimationEukStore = {
    namespaced: true,
    state: {
        current_course: {},
        new_data_modules_current_course: [],
        loading_update_course: false,
        loading_get_tech_map: false
    },

    getters: {

    },

    mutations: {
        setCurrentCourse(state, response){
            state.current_course = response
        },
        setNewDataModulesCourse(state, payload){
            state.new_data_modules_current_course = payload
        },
        resetStadyEstimationEukStore(state){
            state.current_course = {}
            state.new_data_modules_current_course = []
            state.loading_update_course = false
            state.loading_get_tech_map = false
        }
    },

    actions: {
        async getCurrentCourse({state, commit}) {
            state.loading_get_tech_map = true
            const response = await studyEstimationEukApi.index();
            if (_.isNull(response)) return;

            const resp = await store.dispatch("studyEstEukTechMap/getTechnicalMap", response.data.course_id).finally(()=>(
                state.loading_get_tech_map = false
            ))

            if (_.isNull(resp)) commit("setCurrentCourse", response.data);
        },
        async getAsyncCurrentCourse({state, commit}, params) {
            state.loading_update_course = true
            const response = await studyEstimationEukApi.get_async_current_course(params);
            if (_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                state.loading_update_course = false
                commit("setNewDataModulesCourse", response.data);
            } else {
                console.log('error')
            }
        },
    },
}

export default StudyEstimationEukStore